import React from "react";
import { IconProps } from "../icon";

export const Thermometer_03Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 3h-6m6 4h-6m6 4h-6m-9.5 2.758V4.5a2.5 2.5 0 015 0v9.258a4.5 4.5 0 11-5 0zM9 17.5a1 1 0 11-2 0 1 1 0 012 0z"
    />
  </svg>
);
